export default __webpack_public_path__ + "static/media/frames-logo.1a1701ac.png";